(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $$ (selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  // Listeners on window/document and observers outlive a section's DOM, so they
  // are tracked per section and removed on `shopify:section:unload` (theme editor).
  var listeners = [];
  var observers = [];
  var cleanups = [];
  var scrollers = [];
  var cartRefreshSequence = 0;
  function ownerOf(element) {
    return (element && element.closest && element.closest('.shopify-section')) || null;
  }
  function listen(owner, target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push({ owner: owner, target: target, type: type, handler: handler, options: options });
  }
  function track(owner, observer) {
    observers.push({ owner: owner, observer: observer });
    return observer;
  }
  function onTeardown(owner, callback) {
    cleanups.push({ owner: owner, callback: callback });
  }
  function forEachOwner(items, callback) {
    var groups = [];
    items.forEach(function (item) {
      var owner = ownerOf(item);
      var group = groups.find(function (entry) { return entry.owner === owner; });
      if (!group) {
        group = { owner: owner, items: [] };
        groups.push(group);
      }
      group.items.push(item);
    });
    groups.forEach(function (group) { callback(group.owner, group.items); });
  }
  function teardown(container) {
    if (offscreenObserver) offscreenObserver.unobserve(container);
    function owned(owner) { return Boolean(owner) && (owner === container || container.contains(owner)); }
    listeners = listeners.filter(function (entry) {
      if (!owned(entry.owner)) return true;
      entry.target.removeEventListener(entry.type, entry.handler, entry.options);
      return false;
    });
    observers = observers.filter(function (entry) {
      if (!owned(entry.owner)) return true;
      entry.observer.disconnect();
      return false;
    });
    scrollers = scrollers.filter(function (entry) { return !owned(entry.owner); });
    cleanups = cleanups.filter(function (entry) {
      if (!owned(entry.owner)) return true;
      entry.callback();
      return false;
    });
    window.setTimeout(function () {
      if (!document.querySelector('[data-mobile-menu].is-open')) document.body.classList.remove('ov-menu-open');
      if (!document.querySelector('.ov-popup.is-open, .ov-restock-modal.is-open')) document.body.classList.remove('ov-modal-open');
    }, 0);
  }

  function revealsEnabled() {
    return document.body.dataset.reveals === 'true' && !reducedMotion;
  }
  function depthEnabled() {
    return document.body.dataset.parallax === 'true' && !reducedMotion;
  }
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }
  function wide() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  // One passive scroll listener drives every scroll-linked effect, in two
  // phases so that scrolling never forces layout:
  //   measure(state)  reads geometry and caches it in document coordinates. It
  //                   runs on load, on resize and when the page's height changes.
  //   update(state)   runs on scroll frames. It only does arithmetic on the
  //                   scroll position and writes styles; it reads no layout.
  // Frames run only while the page scrolls, or while an effect returns true
  // because it is still easing; an idle page schedules nothing.
  var scrollFrame = null;
  var scrollEngineBound = false;
  var measureQueued = false;
  var scrollState = { y: 0, lastY: 0, velocity: 0, viewport: 0, width: 0, max: 1, wide: false };
  // An element's box in document coordinates. Measure phase only.
  function docBox(element) {
    var rect = element.getBoundingClientRect();
    var top = rect.top + scrollState.y;
    var height = rect.height || 0;
    return { top: top, height: height, bottom: top + height, left: rect.left || 0, width: rect.width || 0 };
  }
  // Progress (0 to 1) of a tall pinned section through the viewport.
  function pinProgress(box, state) {
    return clamp((state.y - box.top) / Math.max(1, box.height - state.viewport), 0, 1);
  }
  // Writes a style or custom property only when its value changed.
  function writer(element, name) {
    var last = null;
    var custom = name.indexOf('--') === 0;
    return function (value) {
      if (value === last) return;
      last = value;
      if (custom) element.style.setProperty(name, value);
      else element.style[name] = value;
    };
  }
  function runScrollers() {
    scrollFrame = null;
    var y = window.scrollY || window.pageYOffset || 0;
    scrollState.lastY = scrollState.y;
    scrollState.y = y;
    scrollState.velocity = y - scrollState.lastY;
    var list = scrollers.slice();
    if (measureQueued) {
      measureQueued = false;
      scrollState.viewport = window.innerHeight;
      scrollState.width = window.innerWidth;
      scrollState.max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      scrollState.wide = wide();
      list.forEach(function (entry) {
        if (entry.measure) entry.measure(scrollState);
      });
    }
    var again = false;
    list.forEach(function (entry) {
      if (entry.update(scrollState) === true) again = true;
    });
    if (again) requestScrollFrame();
  }
  function requestScrollFrame() {
    if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(runScrollers);
  }
  function requestMeasure() {
    measureQueued = true;
    requestScrollFrame();
  }
  function onScrollFrame(owner, update, measure) {
    if (!scrollEngineBound) {
      scrollEngineBound = true;
      scrollState.y = scrollState.lastY = window.scrollY || window.pageYOffset || 0;
      window.addEventListener('scroll', requestScrollFrame, { passive: true });
      window.addEventListener('resize', requestMeasure, { passive: true });
      window.addEventListener('load', requestMeasure);
      if ('ResizeObserver' in window) new ResizeObserver(requestMeasure).observe(document.body);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(requestMeasure);
    }
    scrollers.push({ owner: owner, update: update, measure: measure || null });
    requestMeasure();
  }

  // Sections that are off screen pause their looping CSS animations.
  var offscreenObserver = null;
  function initOffscreenPause(scope) {
    // Reduced motion finishes every animation at once; nothing is left to pause.
    if (reducedMotion || !('IntersectionObserver' in window)) return;
    var reloaded = scope && scope !== document && scope.classList && scope.classList.contains('shopify-section');
    var targets = reloaded ? [scope] : $$('main > .shopify-section, .ov-footer');
    if (!targets.length) return;
    if (!offscreenObserver) {
      offscreenObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      }, { rootMargin: '160px 0px' });
    }
    targets.forEach(function (section) { offscreenObserver.observe(section); });
  }

  // Whether a section paints a light background, from its own colour or its
  // first child's; null when neither paints one. Measure phase only.
  function isLightSurface(section) {
    var candidates = [section, section.firstElementChild, section.firstElementChild && section.firstElementChild.firstElementChild];
    for (var index = 0; index < candidates.length; index += 1) {
      if (!candidates[index]) continue;
      var match = window.getComputedStyle(candidates[index]).backgroundColor.match(/[\d.]+/g);
      if (match && match.length >= 3 && (match.length < 4 || Number(match[3]) > 0.5)) {
        return (0.2126 * match[0] + 0.7152 * match[1] + 0.0722 * match[2]) > 150;
      }
    }
    return null;
  }

  function focusableElements(container) {
    return $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]', container)
      .filter(function (element) {
        return !element.hidden &&
          element.tabIndex >= 0 &&
          !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
          element.getClientRects().length > 0 &&
          window.getComputedStyle(element).visibility !== 'hidden';
      });
  }

  // Hide every sibling on the path to the dialog. Ancestors of the dialog
  // remain active, even when a product section contains the modal itself.
  function isolateDialog(dialog) {
    var hidden = [];
    var branch = dialog;
    while (branch && branch !== document.body) {
      var parent = branch.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
        hidden.push({ element: sibling, inert: sibling.hasAttribute('inert'), aria: sibling.getAttribute('aria-hidden') });
        sibling.setAttribute('inert', '');
        sibling.setAttribute('aria-hidden', 'true');
      });
      branch = parent;
    }
    return function () {
      hidden.forEach(function (entry) {
        if (!entry.inert) entry.element.removeAttribute('inert');
        if (entry.aria === null) entry.element.removeAttribute('aria-hidden');
        else entry.element.setAttribute('aria-hidden', entry.aria);
      });
      hidden = [];
    };
  }

  function trapFocus(event, container, leadingControl) {
    if (event.key !== 'Tab' || !container) return;
    var items = focusableElements(container);
    if (leadingControl && items.indexOf(leadingControl) === -1) items.unshift(leadingControl);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (event.shiftKey && leadingControl && document.activeElement === items[1]) {
      event.preventDefault();
      leadingControl.focus();
    } else if (!event.shiftKey && leadingControl && document.activeElement === leadingControl && items.length > 1) {
      event.preventDefault();
      items[1].focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  // The opening title is CSS-timed; this only lets a tap or key skip it and
  // removes it from the page once it has played.
  function initIntro() {
    var intro = document.querySelector('[data-intro]');
    var root = document.documentElement;
    if (!intro) return;
    if (!root.classList.contains('ov-intro-on')) {
      intro.hidden = true;
      return;
    }
    function finish() {
      intro.hidden = true;
      root.classList.add('ov-intro-done');
    }
    function skip() {
      root.classList.add('ov-intro-skip');
      window.setTimeout(finish, 380);
    }
    intro.addEventListener('click', skip);
    document.addEventListener('keydown', function onKey() {
      document.removeEventListener('keydown', onKey);
      if (!intro.hidden) skip();
    });
    window.setTimeout(finish, 2500);
  }

  function initHeader(scope) {
    var header = (scope || document).querySelector('[data-ov-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    var owner = ownerOf(header);
    var home = document.body.classList.contains('template-index');

    // --ov-header-h lives on the root, so every write restyles the whole page.
    // It is written on load and when the window's width changes, never while
    // the header is animating into its pill.
    var measuredWidth = -1;
    var setHeaderHeight = function () {
      if (window.innerWidth === measuredWidth) return;
      measuredWidth = window.innerWidth;
      document.documentElement.style.setProperty('--ov-header-h', Math.round(header.offsetHeight) + 'px');
    };
    setHeaderHeight();
    // Full width over the homepage hero; a floating glass pill everywhere else,
    // in light glass over light sections so the pill never turns muddy.
    // The page is mapped once into bands of light and dark sections; a scroll
    // frame only looks up the band under the header.
    var bands = [];
    var headerBottom = 0;
    var condensed = null;
    var onLight = null;
    onScrollFrame(owner, function (state) {
      var nextCondensed = !home || state.y > 60;
      if (nextCondensed !== condensed) {
        condensed = nextCondensed;
        header.classList.toggle('is-condensed', condensed);
      }
      var probe = state.y + headerBottom + 6;
      var light = false;
      for (var index = 0; index < bands.length; index += 1) {
        if (probe >= bands[index].top && probe < bands[index].bottom) {
          light = bands[index].light;
          break;
        }
      }
      light = light && condensed;
      if (light !== onLight) {
        onLight = light;
        header.classList.toggle('is-on-light', light);
      }
    }, function () {
      headerBottom = header.getBoundingClientRect().bottom;
      var pageLight = isLightSurface(document.body) === true;
      bands = $$('main > .shopify-section, .ov-footer').map(function (section) {
        var box = docBox(section);
        var light = isLightSurface(section);
        return { top: box.top, bottom: box.bottom, light: light === null ? pageLight : light };
      });
    });
    listen(owner, window, 'resize', setHeaderHeight, { passive: true });

    var button = document.querySelector('[data-menu-button]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;
    var menuOpener = null;

    function closeMenu(restoreFocus) {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', button.dataset.openLabel || 'Open menu');
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ov-menu-open');
      if (restoreFocus && menuOpener && typeof menuOpener.focus === 'function') menuOpener.focus();
    }

    button.addEventListener('click', function () {
      var opening = button.getAttribute('aria-expanded') !== 'true';
      if (opening) menuOpener = document.activeElement;
      button.setAttribute('aria-expanded', String(opening));
      button.setAttribute('aria-label', opening ? (button.dataset.closeLabel || 'Close menu') : (button.dataset.openLabel || 'Open menu'));
      menu.classList.toggle('is-open', opening);
      menu.setAttribute('aria-hidden', String(!opening));
      document.body.classList.toggle('ov-menu-open', opening);
      if (opening) button.focus();
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu(false);
    });
    listen(owner, document, 'keydown', function (event) {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeMenu(true);
      else trapFocus(event, menu, button);
    });
    listen(owner, window, 'resize', function () {
      if (wide() && menu.classList.contains('is-open')) closeMenu(false);
    });

    // Nav items that are buttons (the Explain menu): a click opens the panel
    // and a second click, Escape or a click elsewhere closes it. In the bar a
    // resting mouse opens it too, as it does for Shop; a click then keeps it.
    $$('[data-nav-group]', header.parentNode).forEach(function (group) {
      var toggle = group.querySelector('[data-nav-toggle]');
      var panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
      if (!toggle || !panel) return;
      var inBar = !!group.closest('.ov-nav');
      var byMouse = false;

      function isOpen() { return group.classList.contains('is-open'); }
      function setOpen(open) {
        byMouse = false;
        group.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (!inBar) panel.hidden = !open;
      }

      toggle.addEventListener('click', function () {
        if (byMouse) byMouse = false;
        else setOpen(!isOpen());
      });
      group.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !isOpen()) return;
        event.stopPropagation();
        setOpen(false);
        toggle.focus();
      });
      if (!inBar) return;

      group.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse' || isOpen()) return;
        setOpen(true);
        byMouse = true;
      });
      group.addEventListener('pointerleave', function () {
        if (byMouse) setOpen(false);
      });
      group.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !group.contains(event.relatedTarget)) setOpen(false);
      });
      listen(owner, document, 'pointerdown', function (event) {
        if (isOpen() && !group.contains(event.target)) setOpen(false);
      });
    });
  }

  function initPopup(scope) {
    var popup = (scope || document).querySelector('[data-newsletter-popup]');
    if (!popup || popup.dataset.ready) return;
    popup.dataset.ready = 'true';
    var owner = ownerOf(popup);
    var closeButtons = $$('[data-popup-close]', popup);
    var storageKey = 'onevine-pre-first-drop-popup-dismissed';
    var delay = parseInt(popup.dataset.delay || '8', 10) * 1000;
    var popupOpener = null;
    var restoreBackground = null;
    var popupTimer = null;

    onTeardown(owner, function () {
      window.clearTimeout(popupTimer);
      if (restoreBackground) restoreBackground();
    });

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      if (restoreBackground) restoreBackground();
      restoreBackground = null;
      if (!document.querySelector('.ov-restock-modal.is-open')) document.body.classList.remove('ov-modal-open');
      try { localStorage.setItem(storageKey, 'true'); } catch (error) {}
      if (popupOpener && typeof popupOpener.focus === 'function') popupOpener.focus();
    }

    function openPopup() {
      if (!popup.isConnected) return;
      // Never interrupt someone already signing up on the page.
      var activeForm = document.activeElement && document.activeElement.closest('form.ov-newsletter-form');
      if (activeForm && !popup.contains(activeForm)) return;
      if (document.body.classList.contains('ov-menu-open') || document.querySelector('.ov-restock-modal.is-open')) {
        popupTimer = window.setTimeout(openPopup, 1000);
        return;
      }
      if (popup.classList.contains('is-open')) return;
      popupOpener = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ov-modal-open');
      var close = popup.querySelector('[data-popup-close]');
      if (close) close.focus();
      restoreBackground = isolateDialog(popup);
    }

    closeButtons.forEach(function (button) { button.addEventListener('click', closePopup); });
    popup.addEventListener('click', function (event) {
      if (event.target === popup) closePopup();
    });
    listen(owner, document, 'keydown', function (event) {
      if (!popup.classList.contains('is-open')) return;
      if (event.key === 'Escape') closePopup();
      else trapFocus(event, popup);
    });

    var submittedPopupForm = popup.querySelector('form.ov-newsletter-form');
    var popupSuccess = submittedPopupForm && submittedPopupForm.querySelector('[data-newsletter-success]:not([hidden])');
    var popupError = submittedPopupForm && submittedPopupForm.querySelector('[data-newsletter-error]:not([hidden])');
    if ((popupSuccess || popupError) && submittedPopupForm && window.location.hash !== '#' + submittedPopupForm.id) {
      if (popupSuccess) popupSuccess.hidden = true;
      if (popupError) popupError.hidden = true;
      var popupIntro = submittedPopupForm.querySelector('[data-popup-intro]');
      if (popupIntro) popupIntro.hidden = false;
      var popupFields = submittedPopupForm.querySelector('[data-newsletter-fields]');
      if (popupFields) popupFields.hidden = false;
      popupSuccess = null;
      popupError = null;
    }
    if ((popupSuccess || popupError) && window.location.hash === '#' + submittedPopupForm.id) {
      openPopup();
      return;
    }

    var dismissed = false;
    try { dismissed = localStorage.getItem(storageKey) === 'true'; } catch (error) {}
    var introDelay = document.documentElement.classList.contains('ov-intro-on') ? 2500 : 0;
    if (!dismissed && !(window.Shopify && window.Shopify.designMode)) popupTimer = window.setTimeout(openPopup, delay + introDelay);
  }

  function initNewsletterResults(scope) {
    $$('form.ov-newsletter-form:not([data-result-ready])', scope || document).forEach(function (form) {
      form.dataset.resultReady = 'true';
      if (window.location.hash === '#' + form.id) return;
      var success = form.querySelector('[data-newsletter-success]:not([hidden])');
      var error = form.querySelector('[data-newsletter-error]:not([hidden])');
      if (!success && !error) return;
      var fields = form.querySelector('[data-newsletter-fields]');
      if (fields) fields.hidden = false;
      if (success) success.hidden = true;
      if (error) error.hidden = true;
    });
  }

  function initHero(scope) {
    var film = (scope || document).querySelector('[data-hero-film]');
    if (!film || film.dataset.ready) return;
    film.dataset.ready = 'true';
    var owner = ownerOf(film);

    function showFilm() { film.classList.add('is-ready'); }
    if (film.readyState >= 2) showFilm();
    else film.addEventListener('loadeddata', showFilm, { once: true });

    film.muted = true;
    if (reducedMotion) {
      film.removeAttribute('loop');
      film.removeAttribute('autoplay');
      film.pause();
      return;
    }

    var filmInView = true;
    function playFilm() {
      if (document.hidden || !filmInView) return;
      var promise = film.play();
      if (promise && promise.catch) promise.catch(function () {});
    }
    playFilm();
    listen(owner, document, 'visibilitychange', function () {
      if (document.hidden) film.pause();
      else playFilm();
    });
    onTeardown(owner, function () { film.pause(); });
    if ('IntersectionObserver' in window) {
      var observer = track(owner, new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          filmInView = entry.isIntersecting;
          if (filmInView) playFilm();
          else {
            film.pause();
          }
        });
      }, { threshold: 0.05 }));
      observer.observe(film);
    }
  }

  // Scroll-out depth for the hero (--ov-hero-p, 0 to 1) and a pointer-led tilt
  // with a moving glare on the film window.
  function initHeroDepth(scope) {
    var hero = (scope || document).querySelector('[data-hero]');
    if (!hero || hero.dataset.depthReady) return;
    hero.dataset.depthReady = 'true';
    var owner = ownerOf(hero);
    onTeardown(owner, function () { delete hero.dataset.depthReady; });
    if (!depthEnabled()) return;

    var heroBox = { top: 0, height: 1, bottom: 1, left: 0, width: 1 };
    var stage = hero.querySelector('[data-tilt]');
    var stageBox = null;
    // The progress is written on the three elements that use it, not on the
    // hero, so the rest of the hero is not restyled on every frame.
    var progressWriters = $$('.ov-hero__row--a, .ov-hero__row--c, .ov-hero__window', hero).map(function (element) {
      return writer(element, '--ov-hero-p');
    });
    var away = null;
    onScrollFrame(owner, function (state) {
      var progress = clamp((state.y - heroBox.top) / Math.max(1, heroBox.height), 0, 1).toFixed(3);
      progressWriters.forEach(function (write) { write(progress); });
      var nextAway = state.y > heroBox.bottom;
      if (nextAway !== away) {
        away = nextAway;
        hero.classList.toggle('is-away', away);
      }
    }, function () {
      heroBox = docBox(hero);
      // The window's box is taken at rest: the tilt and the scroll drift move it.
      if (stage && (!stageBox || (!stage.classList.contains('is-tilting') && scrollState.y <= heroBox.top))) stageBox = docBox(stage);
    });

    if (!stage || !finePointer) return;
    var target = { x: 0, y: 0 };
    var current = { x: 0, y: 0 };
    var glare = null;
    var frame = null;
    // Pointer moves only record a target; one frame applies the latest of them.
    function step() {
      frame = null;
      current.x += (target.x - current.x) * 0.08;
      current.y += (target.y - current.y) * 0.08;
      stage.style.setProperty('--ov-rx', current.x.toFixed(4));
      stage.style.setProperty('--ov-ry', current.y.toFixed(4));
      if (glare) {
        stage.style.setProperty('--ov-gx', glare.x);
        stage.style.setProperty('--ov-gy', glare.y);
        glare = null;
      }
      if (Math.abs(target.x - current.x) > 0.0005 || Math.abs(target.y - current.y) > 0.0005) frame = window.requestAnimationFrame(step);
    }
    function kick() {
      if (frame === null) frame = window.requestAnimationFrame(step);
    }
    listen(owner, hero, 'pointermove', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      if (!stageBox) return;
      // Page coordinates against the cached boxes: no layout is read here.
      var x = event.pageX - stageBox.left;
      var y = event.pageY - stageBox.top;
      target.x = clamp((x - stageBox.width / 2) / (heroBox.width / 2), -1, 1);
      target.y = clamp((y - stageBox.height / 2) / (heroBox.height / 2), -1, 1);
      glare = {
        x: clamp(x / stageBox.width * 100, -20, 120).toFixed(1) + '%',
        y: clamp(y / stageBox.height * 100, -20, 120).toFixed(1) + '%'
      };
      stage.classList.add('is-tilting');
      kick();
    });
    listen(owner, hero, 'pointerleave', function () {
      target.x = 0;
      target.y = 0;
      stage.classList.remove('is-tilting');
      kick();
    });
    onTeardown(owner, function () {
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = null;
    });
  }

  // Wraps each word (or letter) in a mask so it can rise into place. Element
  // structure such as <em> is kept; only text nodes are replaced.
  function splitText(item) {
    if (item.classList.contains('is-split')) return;
    var byChar = item.dataset.reveal === 'chars';
    var index = 0;
    var walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.nodeValue.trim()) return;
      var fragment = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        if (byChar) {
          var group = document.createElement('span');
          group.className = 'ov-chars-word';
          Array.from(part).forEach(function (character) {
            var outer = document.createElement('span');
            var inner = document.createElement('span');
            outer.className = 'ov-char';
            inner.className = 'ov-char__inner';
            inner.style.setProperty('--c', index);
            index += 1;
            inner.textContent = character;
            outer.appendChild(inner);
            group.appendChild(outer);
          });
          fragment.appendChild(group);
        } else {
          var word = document.createElement('span');
          var wordInner = document.createElement('span');
          word.className = 'ov-word';
          wordInner.className = 'ov-word__inner';
          wordInner.style.setProperty('--w', index);
          index += 1;
          wordInner.textContent = part;
          word.appendChild(wordInner);
          fragment.appendChild(word);
        }
      });
      node.parentNode.replaceChild(fragment, node);
    });
    item.classList.add('is-split');
  }

  function initReveals(scope) {
    var revealItems = $$('[data-reveal]:not([data-reveal-ready])', scope || document);
    if (!revealItems.length) return;

    if (!revealsEnabled() || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    // The first pass spans the document; each section still needs its own observer.
    // The root reaches far above the viewport, so anything a fast scroll carried
    // past without a sampled intersection still counts as seen.
    forEachOwner(revealItems, function (owner, items) {
      var active = true;
      var observer = track(owner, new IntersectionObserver(function (entries) {
        if (!active) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var item = entry.target;
          item.classList.add('is-visible');
          observer.unobserve(item);
        });
      }, { threshold: 0.12, rootMargin: '9999px 0px -6% 0px' }));
      onTeardown(owner, function () {
        active = false;
        items.forEach(function (item) { delete item.dataset.revealReady; });
      });
      items.forEach(function (item) {
        item.dataset.revealReady = 'true';
        item.style.setProperty('--ov-delay', parseInt(item.dataset.delay || '0', 10) + 'ms');
        if (item.dataset.reveal === 'split' || item.dataset.reveal === 'chars') splitText(item);
        observer.observe(item);
      });
    });
  }

  function initMissionWords(scope) {
    var wrappers = $$('[data-mission-words]:not([data-ready])', scope || document);
    wrappers.forEach(function (wrapper) {
      wrapper.dataset.ready = 'true';
      var owner = ownerOf(wrapper);
      var words = $$('span', wrapper);
      if (!words.length || reducedMotion) {
        words.forEach(function (word) { word.style.opacity = '1'; });
        return;
      }

      var forced = false;
      var box = { top: 0, height: 0, bottom: 0 };
      var applied = words.map(function () { return ''; });
      function revealAll() {
        forced = true;
        wrapper.dataset.forceReveal = 'true';
        words.forEach(function (word) { word.style.opacity = '1'; });
      }
      function update(state) {
        if (forced) return;
        var top = box.top - state.y;
        if (top + box.height < 0 || top > state.viewport) return;
        var start = state.viewport * 0.88;
        var end = state.viewport * 0.32;
        var progress = clamp((start - top) / (start - end), 0, 1);
        // Most words are already fully lit or still dim; only the few in
        // between change on a given frame.
        words.forEach(function (word, index) {
          var amount = clamp((progress * (words.length + 6) - index) / 4, 0, 1);
          var value = (0.14 + amount * 0.86).toFixed(2);
          if (value === applied[index]) return;
          applied[index] = value;
          word.style.opacity = value;
        });
      }
      onScrollFrame(owner, update, function () { box = docBox(wrapper); });
      listen(owner, window, 'hashchange', function () {
        if (window.location.hash === '#mission') revealAll();
      });
      listen(owner, document, 'click', function (event) {
        var missionLink = event.target.closest('a[href$="#mission"]');
        if (missionLink) revealAll();
      });
      if (window.location.hash === '#mission') revealAll();
    });
  }

  function initParallax(scope) {
    if (!depthEnabled()) return;
    // The body's data-parallax is the feature flag, not an animated target.
    var items = $$('[data-parallax]:not([data-ready])', scope || document).filter(function (item) {
      return item !== document.body;
    });
    if (!items.length) return;
    forEachOwner(items, function (owner, ownedItems) {
      ownedItems.forEach(function (item) { item.dataset.ready = 'true'; });
      // Each item drifts with its section's passage through the viewport. The
      // section is the reference because it never moves, while an item inside a
      // sticky column does.
      var frames = ownedItems.map(function (item) {
        return { box: { top: 0, height: 0 }, speed: parseFloat(item.dataset.parallax || '0'), write: writer(item, 'transform') };
      });
      onScrollFrame(owner, function (state) {
        frames.forEach(function (frame) {
          var top = frame.box.top - state.y;
          if (top > state.viewport * 1.6 || top + frame.box.height < -state.viewport * 0.6) return;
          var offset = clamp((top + frame.box.height / 2 - state.viewport / 2) * frame.speed, -60, 60);
          frame.write('translate3d(0,' + offset.toFixed(1) + 'px,0)');
        });
      }, function () {
        ownedItems.forEach(function (item, index) { frames[index].box = docBox(owner || item); });
      });
      onTeardown(owner, function () {
        ownedItems.forEach(function (item) { delete item.dataset.ready; });
      });
    });
  }

  // The scripture marquee is a plain compositor animation at its set speed. It
  // slows under the pointer so the verse can be read.
  function initMarquee(scope) {
    $$('[data-marquee]:not([data-ready])', scope || document).forEach(function (marquee) {
      marquee.dataset.ready = 'true';
      var owner = ownerOf(marquee);
      onTeardown(owner, function () { delete marquee.dataset.ready; });
      if (reducedMotion) return;
      var trackElement = marquee.querySelector('.ov-marquee__track');
      function setRate(value) {
        var animation = trackElement && trackElement.getAnimations && trackElement.getAnimations()[0];
        if (!animation) return;
        if (animation.updatePlaybackRate) animation.updatePlaybackRate(value);
        else animation.playbackRate = value;
      }
      marquee.addEventListener('mouseenter', function () { setRate(0.25); });
      marquee.addEventListener('mouseleave', function () { setRate(1); });
    });
  }

  // Pinned scroll scene. The stylesheet derives every stage of the scene from
  // --p for the no-script state; here the same curves are computed once per
  // frame and each number is written on the one element that uses it, so a
  // frame restyles a handful of elements instead of the whole scene.
  function initQuestion(scope) {
    $$('[data-question]:not([data-ready])', scope || document).forEach(function (scene) {
      scene.dataset.ready = 'true';
      var owner = ownerOf(scene);
      var cluster = scene.querySelector('.ov-question__cluster');
      var photo = scene.querySelector('.ov-question__photo');
      var words = scene.querySelector('.ov-question__words');
      var reply = scene.querySelector('.ov-question__reply span');
      var bubbles = $$('.ov-qb', scene);
      var targets = [[cluster, ['--ov-cm']], [photo, ['--ke']], [words, ['--h']], [reply, ['--r']]]
        .concat(bubbles.map(function (bubble) { return [bubble, ['--s', '--t', '--me']]; }));
      onTeardown(owner, function () {
        delete scene.dataset.ready;
        scene.classList.remove('is-scrubbed');
        targets.forEach(function (target) {
          if (target[0]) target[1].forEach(function (name) { target[0].style.removeProperty(name); });
        });
      });
      if (!revealsEnabled()) return;
      scene.classList.add('is-scrubbed');
      function ease(value) { return value * value * (3 - 2 * value); }
      function set(element, name) { return element ? writer(element, name) : function () {}; }
      var setCluster = set(cluster, '--ov-cm');
      var setPhoto = set(photo, '--ke');
      var setWords = set(words, '--h');
      var setReply = set(reply, '--r');
      var setBubbles = bubbles.map(function (bubble) {
        return {
          at: parseFloat(bubble.style.getPropertyValue('--at')) || 0,
          show: writer(bubble, '--s'), type: writer(bubble, '--t'), leave: writer(bubble, '--me')
        };
      });
      var box = { top: 0, height: 0, bottom: 0 };
      onScrollFrame(owner, function (state) {
        if (state.y > box.bottom + state.viewport || state.y + state.viewport * 3 < box.top) return;
        var progress = pinProgress(box, state);
        var leaving = ease(clamp((progress - 0.6) / 0.16, 0, 1)).toFixed(3);
        setPhoto(ease(clamp((progress - 0.02) / 0.26, 0, 1)).toFixed(3));
        setCluster(leaving);
        setWords(clamp((progress - 0.64) * 7, 0, 1).toFixed(3));
        setReply(clamp((progress - 0.82) * 10, 0, 1).toFixed(3));
        setBubbles.forEach(function (bubble) {
          bubble.show(clamp((progress - bubble.at + 0.05) * 20, 0, 1).toFixed(3));
          bubble.type(clamp((progress - bubble.at) * 16, 0, 1).toFixed(3));
          bubble.leave(leaving);
        });
      }, function () { box = docBox(scene); });
    });
  }

  // Wide screens: the lookbook pins and the page scroll pans it sideways.
  function initLookbook(scope) {
    $$('[data-lookbook]:not([data-lookbook-ready])', scope || document).forEach(function (section) {
      section.dataset.lookbookReady = 'true';
      var owner = ownerOf(section);
      var viewport = section.querySelector('[data-lookbook-viewport]');
      var trackElement = section.querySelector('[data-lookbook-track]');
      var countElement = section.querySelector('[data-lookbook-count]');
      var totalElement = section.querySelector('[data-lookbook-total]');
      var progressElement = section.querySelector('[data-lookbook-progress]');
      if (!viewport || !trackElement) return;
      var distance = 0;
      var pinned = false;
      var skew = 0;
      var shift = 0;
      var box = { top: 0, height: 0, bottom: 0 };
      var trackLeft = 0;
      var centers = [];
      var lefts = [];
      var lean = depthEnabled();
      var setTrack = writer(trackElement, 'transform');
      var setBar = progressElement ? writer(progressElement, 'transform') : function () {};
      var shownCount = '';

      function cards() {
        return $$('.ov-product-card', trackElement).filter(function (card) { return !card.hidden; });
      }
      function pad(number) { return (number < 10 ? '0' : '') + number; }
      function setCount(index) {
        var text = pad(index + 1);
        if (!countElement || text === shownCount) return;
        shownCount = text;
        countElement.textContent = text;
      }
      function layout() {
        var canPin = revealsEnabled() && wide();
        if (canPin !== pinned) {
          pinned = canPin;
          section.classList.toggle('is-pinned', pinned);
          if (!pinned) {
            section.style.height = '';
            setTrack('');
            shift = 0;
          }
        }
        if (totalElement) totalElement.textContent = pad(cards().length);
        if (pinned) {
          distance = Math.max(0, trackElement.scrollWidth - viewport.clientWidth);
          section.style.height = 'calc(100vh + ' + Math.round(distance) + 'px)';
        }
        requestMeasure();
      }
      layout();
      listen(owner, window, 'resize', layout, { passive: true });
      section.addEventListener('ov:lookbook-refresh', layout);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
      onTeardown(owner, function () {
        delete section.dataset.lookbookReady;
        section.classList.remove('is-pinned');
        section.style.height = '';
      });

      onScrollFrame(owner, function (state) {
        if (!pinned) return false;
        if (state.y + state.viewport < box.top || state.y > box.bottom) return false;
        var progress = clamp((state.y - box.top) / Math.max(1, distance), 0, 1);
        shift = progress * distance;
        // A slight lean in the direction of travel that settles when scrolling
        // stops. It rides on the track's own transform, so nothing repaints.
        var goal = lean ? clamp(state.velocity * 0.05, -4, 4) : 0;
        skew += (goal - skew) * 0.18;
        if (Math.abs(skew - goal) < 0.01) skew = goal;
        setTrack('translate3d(' + (-shift).toFixed(1) + 'px,0,0)' + (skew ? ' skewX(' + (-skew).toFixed(2) + 'deg)' : ''));
        setBar('scaleX(' + progress.toFixed(4) + ')');
        var focus = state.width * 0.3 - trackLeft + shift;
        var nearest = 0;
        for (var index = 1; index < centers.length; index += 1) {
          if (Math.abs(centers[index] - focus) < Math.abs(centers[nearest] - focus)) nearest = index;
        }
        setCount(nearest);
        return skew !== 0;
      }, function () {
        // Card positions are taken relative to the track, so the track's own
        // movement cancels out of the measurement.
        box = docBox(section);
        var trackRect = trackElement.getBoundingClientRect();
        trackLeft = trackRect.left + shift;
        var visible = cards();
        centers = visible.map(function (card) {
          var rect = card.getBoundingClientRect();
          return rect.left - trackRect.left + rect.width / 2;
        });
        lefts = visible.map(function (card) { return card.getBoundingClientRect().left - trackRect.left; });
      });

      // Phones swipe the row natively; only the counter follows.
      var countFrame = null;
      listen(owner, viewport, 'scroll', function () {
        if (pinned || countFrame !== null) return;
        countFrame = window.requestAnimationFrame(function () {
          countFrame = null;
          var left = viewport.scrollLeft;
          var active = 0;
          lefts.forEach(function (cardLeft, index) { if (cardLeft - 40 <= left) active = index; });
          setCount(active);
        });
      }, { passive: true });
    });
  }

  // "We Eat God" portal: the scroll flies through the O of the last word.
  function initPortal(scope) {
    $$('[data-portal]:not([data-ready])', scope || document).forEach(function (portal) {
      portal.dataset.ready = 'true';
      var owner = ownerOf(portal);
      var words = portal.querySelector('[data-portal-words]');
      onTeardown(owner, function () {
        delete portal.dataset.ready;
        portal.classList.remove('is-scrubbed', 'is-open');
      });
      if (!words) return;
      if (!words.dataset.split) {
        words.dataset.split = 'true';
        // The letters are windows onto the scene, so the flight aims at a
        // letter's solid stroke (a T or I stem), never an empty counter.
        var parts = words.textContent.trim().split(/\s+/);
        var strokes = { T: [0.5, 0.72], I: [0.5, 0.5], L: [0.2, 0.5], E: [0.14, 0.5], H: [0.14, 0.5], N: [0.14, 0.5] };
        var order = parts.map(function (_, index) { return index; }).sort(function (a, b) {
          return Math.abs(a - (parts.length - 1) / 2) - Math.abs(b - (parts.length - 1) / 2);
        });
        var pick = null;
        Object.keys(strokes).some(function (letter) {
          return order.some(function (wordIndex) {
            var at = parts[wordIndex].toUpperCase().indexOf(letter);
            if (at < 0) return false;
            pick = { word: wordIndex, index: at, point: strokes[letter] };
            return true;
          });
        });
        if (!pick) pick = { word: parts.length - 1, index: Math.floor(parts[parts.length - 1].length / 2), point: [0.5, 0.5] };
        words.textContent = '';
        parts.forEach(function (part, index) {
          var line = document.createElement('span');
          line.className = 'ov-portal__line';
          if (index === pick.word) {
            line.appendChild(document.createTextNode(part.slice(0, pick.index)));
            var letter = document.createElement('span');
            letter.className = 'ov-portal__focus';
            letter.dataset.fx = pick.point[0];
            letter.dataset.fy = pick.point[1];
            letter.textContent = part.charAt(pick.index);
            line.appendChild(letter);
            line.appendChild(document.createTextNode(part.slice(pick.index + 1)));
          } else {
            line.textContent = part;
          }
          words.appendChild(line);
        });
      }
      if (!revealsEnabled()) return;
      portal.classList.add('is-scrubbed');
      var origin = null;
      function measure() {
        var focusLetter = words.querySelector('.ov-portal__focus');
        if (!focusLetter) return;
        var previous = words.style.transform;
        words.style.transform = 'none';
        var box = words.getBoundingClientRect();
        var letterBox = focusLetter.getBoundingClientRect();
        words.style.transform = previous;
        origin = {
          x: letterBox.left + letterBox.width * Number(focusLetter.dataset.fx || 0.5) - box.left,
          y: letterBox.top + letterBox.height * Number(focusLetter.dataset.fy || 0.5) - box.top
        };
        words.style.transformOrigin = origin.x.toFixed(1) + 'px ' + origin.y.toFixed(1) + 'px';
        requestMeasure();
      }
      measure();
      listen(owner, window, 'resize', measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

      var box = { top: 0, height: 0, bottom: 0 };
      // Each value goes on the element that uses it, not on the whole portal.
      var image = portal.querySelector('.ov-portal__image');
      var mask = portal.querySelector('[data-portal-mask]');
      var setScale = writer(words, 'transform');
      var setZoom = image ? writer(image, '--q') : function () {};
      var setMask = mask ? writer(mask, '--mo') : function () {};
      var open = null;
      onScrollFrame(owner, function (state) {
        if (state.y > box.bottom + state.viewport || state.y + state.viewport * 3 < box.top) return;
        var progress = pinProgress(box, state);
        var zoom = clamp((progress - 0.1) / 0.58, 0, 1);
        var eased = zoom * zoom * zoom;
        setScale('scale(' + (1 + eased * 70).toFixed(3) + ')');
        setZoom(zoom.toFixed(3));
        setMask(clamp(1 - (zoom - 0.82) / 0.18, 0, 1).toFixed(2));
        var nextOpen = progress > 0.64;
        if (nextOpen !== open) {
          open = nextOpen;
          portal.classList.toggle('is-open', open);
        }
      }, function () { box = docBox(portal); });
    });
  }

  function initMagnetic(scope) {
    $$('.ov-btn:not([data-fill-ready]), .ov-field__submit:not([data-fill-ready])', scope || document).forEach(function (button) {
      button.dataset.fillReady = 'true';
      // The hover fill grows from wherever the pointer entered.
      button.addEventListener('pointerenter', function (event) {
        var rect = button.getBoundingClientRect();
        button.style.setProperty('--bx', (event.clientX - rect.left).toFixed(0) + 'px');
        button.style.setProperty('--by', (event.clientY - rect.top).toFixed(0) + 'px');
      });
    });
    if (!depthEnabled() || !finePointer) return;
    $$('[data-magnetic]:not([data-magnetic-ready])', scope || document).forEach(function (element) {
      element.dataset.magneticReady = 'true';
      // The resting box is read once on entry; reading it while the button is
      // displaced would feed the pull back into itself.
      var rest = null;
      element.addEventListener('pointerenter', function () {
        element.style.transform = '';
        rest = element.getBoundingClientRect();
      });
      element.addEventListener('pointermove', function (event) {
        if (!rest) return;
        var x = (event.clientX - rest.left - rest.width / 2) * 0.26;
        var y = (event.clientY - rest.top - rest.height / 2) * 0.4;
        element.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      });
      element.addEventListener('pointerleave', function () {
        rest = null;
        element.style.transform = '';
      });
    });
  }

  function initCounters(scope) {
    var items = $$('[data-count-to]:not([data-ready])', scope || document);
    if (!items.length) return;
    items.forEach(function (item) { item.dataset.ready = 'true'; });
    if (!revealsEnabled() || !('IntersectionObserver' in window)) return;

    function count(item) {
      var number = item.querySelector('.ov-count__num');
      var goal = parseFloat(item.dataset.countTo);
      var suffix = item.dataset.countSuffix || '';
      if (!number || !isFinite(goal)) return;
      // Hold the final width so nothing around the figure shifts.
      number.style.display = 'inline-block';
      number.style.minWidth = number.getBoundingClientRect().width + 'px';
      var shown = '0' + suffix;
      number.textContent = shown;
      var start = null;
      function step(time) {
        if (start === null) start = time;
        var progress = Math.min(1, (time - start) / 1800);
        var eased = 1 - Math.pow(1 - progress, 4);
        // The text is replaced only when the figure changes, not on every frame.
        var next = Math.round(goal * eased) + suffix;
        if (next !== shown) {
          shown = next;
          number.textContent = next;
        }
        if (progress < 1) window.requestAnimationFrame(step);
      }
      window.setTimeout(function () { window.requestAnimationFrame(step); }, 300);
    }

    forEachOwner(items, function (owner, ownedItems) {
      var observer = track(owner, new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          count(entry.target);
        });
      }, { threshold: 0.5 }));
      ownedItems.forEach(function (item) { observer.observe(item); });
      onTeardown(owner, function () {
        ownedItems.forEach(function (item) { delete item.dataset.ready; });
      });
    });
  }

  // The explainer's markup is left as written; its lower blocks wait, paused,
  // until they scroll into view.
  function initInView(scope) {
    var items = $$('.ov-weg-restored__block, .ov-weg-restored__conclusion-line, .ov-weg-restored__cta', scope || document).filter(function (item) {
      return !item.dataset.inviewReady;
    });
    if (!items.length) return;
    items.forEach(function (item) { item.dataset.inviewReady = 'true'; });
    if (!revealsEnabled() || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-inview'); });
      return;
    }
    forEachOwner(items, function (owner, ownedItems) {
      var observer = track(owner, new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '9999px 0px 0px 0px' }));
      ownedItems.forEach(function (item) { observer.observe(item); });
      onTeardown(owner, function () {
        ownedItems.forEach(function (item) { delete item.dataset.inviewReady; });
      });
    });
  }

  function initFilters(scope) {
    $$('.ov-collection[data-product-filter]:not([data-ready])', scope || document).forEach(function (section) {
      section.dataset.ready = 'true';
      var owner = ownerOf(section);
      var buttons = $$('[data-filter]', section);
      var cards = $$('[data-filter-keys]', section);
      var grid = section.querySelector('[data-product-grid]');
      var empty = section.querySelector('[data-filter-empty]');
      var group = section.querySelector('.ov-filters');
      var indicator = section.querySelector('[data-filter-indicator]');

      function moveIndicator(button, instant) {
        if (!indicator || !group || !button) return;
        if (instant) indicator.style.transition = 'none';
        indicator.style.setProperty('--ov-x', button.offsetLeft + 'px');
        indicator.style.setProperty('--ov-w', button.offsetWidth + 'px');
        if (instant) {
          void indicator.offsetWidth;
          indicator.style.transition = '';
        }
        group.classList.add('has-indicator');
      }
      function syncIndicator() {
        moveIndicator(section.querySelector('[data-filter].is-active'), true);
      }
      syncIndicator();
      listen(owner, window, 'resize', syncIndicator, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncIndicator);

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.dataset.filter;
          buttons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          moveIndicator(button, false);

          // FLIP: remember where the visible cards were, apply the filter, then
          // animate each card from its old box to its new one.
          var animate = !reducedMotion && typeof cards[0] !== 'undefined' && typeof cards[0].animate === 'function';
          var before = cards.map(function (card) { return animate && !card.hidden ? card.getBoundingClientRect() : null; });
          var visible = 0;
          cards.forEach(function (card) {
            var show = value === 'all' || (' ' + card.dataset.filterKeys + ' ').indexOf(' ' + value + ' ') !== -1;
            card.hidden = !show;
            if (show) visible += 1;
          });
          if (empty) empty.hidden = visible !== 0;
          if (grid) grid.classList.toggle('is-filtered', value !== 'all');
          section.dispatchEvent(new CustomEvent('ov:lookbook-refresh'));
          if (!animate) return;
          var entering = 0;
          cards.forEach(function (card, index) {
            if (card.hidden) return;
            card.classList.add('is-visible');
            var after = card.getBoundingClientRect();
            var previous = before[index];
            if (previous) {
              card.animate([
                { transform: 'translate(' + (previous.left - after.left) + 'px,' + (previous.top - after.top) + 'px)' },
                { transform: 'none' }
              ], { duration: 720, easing: 'cubic-bezier(.22,1,.36,1)' });
            } else {
              card.animate([
                { opacity: 0, transform: 'translateY(26px) scale(.96)' },
                { opacity: 1, transform: 'none' }
              ], { duration: 640, delay: entering * 60, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
              entering += 1;
            }
          });
        });
      });
    });
  }

  function initProductImageGuard(scope) {
    $$('[data-main-product-image], .ov-product__thumb img, .ov-product-card__media img', scope).forEach(function (image) {
      if (image.dataset.photoGuardReady === 'true') return;
      image.dataset.photoGuardReady = 'true';
      image.setAttribute('draggable', 'false');
      var owner = ownerOf(image);
      function preventPhotoAction(event) { event.preventDefault(); }
      listen(owner, image, 'contextmenu', preventPhotoAction);
      listen(owner, image, 'dragstart', preventPhotoAction);
      onTeardown(owner, function () { delete image.dataset.photoGuardReady; });
    });
  }

  function initProductCardSlideshows(scope) {
    $$('[data-card-slideshow]:not([data-ready])', scope || document).forEach(function (slideshow) {
      slideshow.dataset.ready = 'true';
      var card = slideshow.closest('.ov-product-card');
      var owner = ownerOf(slideshow);
      var frames = $$('.ov-product-card__frame', slideshow);
      if (!card || frames.length < 2) return;
      var index = 0;
      var timer = null;

      function showFrame(nextIndex) {
        index = (nextIndex + frames.length) % frames.length;
        frames.forEach(function (frame, frameIndex) {
          frame.classList.toggle('is-active', frameIndex === index);
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        showFrame(0);
      }

      card.addEventListener('mouseenter', function () {
        stop();
        if (reducedMotion) {
          showFrame(1);
          return;
        }
        showFrame(1);
        timer = window.setInterval(function () { showFrame(index + 1); }, 900);
      });
      card.addEventListener('mouseleave', stop);
      onTeardown(owner, stop);
    });
  }

  function initProduct(scope) {
    $$('.ov-product[data-product-root]:not([data-ready])', scope || document).forEach(function (root) {
      root.dataset.ready = 'true';
      var owner = ownerOf(root);
      var json = root.querySelector('[data-product-json]');
      var product;
      try { product = JSON.parse(json.textContent); } catch (error) { return; }
      var colorHold = root.dataset.productHandle === 'weeatgod-tshirt';

      function isVariantAllowed(variant) {
        return Boolean(variant && (!colorHold || variant.options[0] === 'Navy' || variant.options[0] === 'White'));
      }

      function resolveVariant(variant) {
        if (!variant || isVariantAllowed(variant)) return variant;
        return product.variants.find(function (item) {
          return isVariantAllowed(item) && item.options[1] === variant.options[1];
        }) || product.variants.find(isVariantAllowed);
      }

      var form = root.querySelector('form.ov-product-form:not(.ov-product-form--native)');
      var variantInput = form && form.querySelector('input[name="id"]');
      var submit = form && form.querySelector('[data-add-to-cart]');
      var mainImage = root.querySelector('[data-main-product-image]');
      var stage = root.querySelector('[data-product-stage]');
      var errorBox = form && form.querySelector('[data-product-error]');
      var optionInputs = $$('[data-option-input]', form);
      var productThumbs = $$('[data-product-thumb]', root);
      var galleryPrev = root.querySelector('[data-product-gallery-prev]');
      var galleryNext = root.querySelector('[data-product-gallery-next]');
      var restockOpen = root.querySelector('[data-restock-open]');
      var restockHelper = root.querySelector('[data-restock-helper]');
      var restockModal = root.querySelector('[data-restock-modal]');
      var restockForm = root.querySelector('form.ov-restock-form');
      var restockTag = restockForm && restockForm.querySelector('[data-restock-tag]');
      var restockSuccess = restockForm && restockForm.querySelector('[data-restock-success]:not([hidden])');
      var restockError = restockForm && restockForm.querySelector('[data-restock-error]:not([hidden])');
      var restockOpener = null;
      var restoreRestockBackground = null;
      var imageRequest = 0;
      var requestPending = false;
      var addedVariantId = null;
      var feedbackTimer = null;
      var disposed = false;
      onTeardown(owner, function () {
        disposed = true;
        imageRequest += 1;
        window.clearTimeout(feedbackTimer);
        if (restoreRestockBackground) restoreRestockBackground();
      });
      if (restockForm && window.location.hash !== '#' + restockForm.id && (restockSuccess || restockError)) {
        var restockFields = restockForm.querySelector('[data-restock-fields]');
        if (restockFields) restockFields.hidden = false;
        if (restockSuccess) restockSuccess.hidden = true;
        if (restockError) restockError.hidden = true;
        restockSuccess = null;
        restockError = null;
      }

      function selectedOptions() {
        return product.options.map(function (_, index) {
          var checked = form.querySelector('[data-option-position="' + (index + 1) + '"]:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant() {
        // Default-only products have no option radios; use the form's actual
        // variant instead of comparing "Default Title" with an empty choice.
        if (!optionInputs.length) {
          return product.variants.find(function (variant) { return variantInput && String(variant.id) === String(variantInput.value); }) || product.variants[0];
        }
        var values = selectedOptions();
        return product.variants.find(function (variant) {
          return isVariantAllowed(variant) && variant.options.every(function (value, index) { return value === values[index]; });
        });
      }

      function updateRestockSelection(variant) {
        if (!variant) return;
        if (restockTag) {
          restockTag.value = 'ov-bis,ov-bis-' + root.dataset.productHandle + '-' + variant.id;
        }
        $$('[data-restock-option-position]', root).forEach(function (item) {
          var position = parseInt(item.dataset.restockOptionPosition || '1', 10) - 1;
          item.textContent = displayOptionValue(variant.options[position] || '');
        });
        var title = root.querySelector('[data-restock-variant-title]');
        if (title) title.textContent = variant.title === 'Default Title' ? root.dataset.productTitle : variant.title;
      }

      function closeRestock(restoreFocus) {
        if (!restockModal) return;
        restockModal.classList.remove('is-open');
        restockModal.setAttribute('aria-hidden', 'true');
        if (restoreRestockBackground) restoreRestockBackground();
        restoreRestockBackground = null;
        if (!document.querySelector('.ov-popup.is-open')) document.body.classList.remove('ov-modal-open');
        if (restoreFocus && restockOpener && typeof restockOpener.focus === 'function') restockOpener.focus();
      }

      function openRestock() {
        if (!restockModal || restockModal.classList.contains('is-open')) return;
        restockOpener = document.activeElement;
        restockModal.classList.add('is-open');
        restockModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ov-modal-open');
        var email = restockModal.querySelector('input[type="email"]');
        var close = restockModal.querySelector('[data-restock-close]');
        if ((restockSuccess || restockError) && close) close.focus();
        else if (email) email.focus();
        restoreRestockBackground = isolateDialog(restockModal);
      }

      function setMainImage(url, alt, srcset) {
        if (!mainImage || !url) return;
        mainImage.style.opacity = '0';
        if (stage) stage.classList.add('is-swapping');
        var currentRequest = ++imageRequest;
        var preloader = new Image();
        preloader.onload = function () {
          if (disposed || currentRequest !== imageRequest) return;
          mainImage.srcset = srcset || '';
          mainImage.src = url;
          mainImage.alt = alt || root.dataset.productTitle || '';
          mainImage.style.opacity = '1';
          if (stage) stage.classList.remove('is-swapping');
        };
        preloader.onerror = function () {
          if (disposed || currentRequest !== imageRequest) return;
          mainImage.style.opacity = '1';
          if (stage) stage.classList.remove('is-swapping');
          if (errorBox) {
            errorBox.hidden = false;
            errorBox.textContent = 'This product image could not be loaded. Please try again.';
          }
        };
        preloader.src = url;
      }

      function normalizeGalleryColor(value) {
        var normalized = String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        return normalized === 'tan' ? 'sand' : normalized;
      }

      function displayOptionValue(value) {
        return normalizeGalleryColor(value) === 'sand' ? 'Sand' : String(value || '');
      }

      function activateThumb(thumb) {
        if (!thumb) return;
        productThumbs.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        setMainImage(thumb.dataset.image, thumb.dataset.alt, thumb.dataset.srcset);
      }

      function updateVisibleGalleryLabels() {
        var visibleThumbs = productThumbs.filter(function (thumb) { return !thumb.hidden; });
        visibleThumbs.forEach(function (thumb, index) {
          var label = 'View image ' + (index + 1) + ' of ' + visibleThumbs.length;
          var description = String(thumb.dataset.alt || '').trim();
          var productTitle = String(root.dataset.productTitle || '').trim();
          if (description && description.toLowerCase() !== productTitle.toLowerCase()) {
            label += ': ' + description;
          }
          thumb.setAttribute('aria-label', label);
        });
        [galleryPrev, galleryNext].forEach(function (button) {
          if (button) button.hidden = visibleThumbs.length < 2;
        });
      }

      function moveGallery(direction) {
        var visibleThumbs = productThumbs.filter(function (thumb) { return !thumb.hidden; });
        if (visibleThumbs.length < 2) return;
        var activeThumb = root.querySelector('[data-product-thumb].is-active');
        var activeIndex = visibleThumbs.indexOf(activeThumb);
        if (activeIndex < 0) activeIndex = 0;
        var nextThumb = visibleThumbs[(activeIndex + direction + visibleThumbs.length) % visibleThumbs.length];
        activateThumb(nextThumb);
        nextThumb.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      }

      function selectedGalleryColor() {
        var checked = form && form.querySelector('[data-option-name="color"]:checked, [data-option-name="colour"]:checked');
        return checked ? normalizeGalleryColor(checked.value) : '';
      }

      function galleryShotOrder(thumb) {
        var imageKey = String((thumb && (thumb.dataset.image || thumb.dataset.alt)) || '').toLowerCase();
        if (imageKey.indexOf('hanging') !== -1) return 1;
        if (imageKey.indexOf('lifestyle') !== -1) return 2;
        if (imageKey.indexOf('front-collar') !== -1 || imageKey.indexOf('front_collar') !== -1 || imageKey.indexOf('collar') !== -1) return 7;
        if (imageKey.indexOf('right-sleeve') !== -1 || imageKey.indexOf('right_sleeve') !== -1) return 5;
        if (imageKey.indexOf('left-sleeve') !== -1 || imageKey.indexOf('left_sleeve') !== -1) return 6;
        if (imageKey.indexOf('back') !== -1) return 4;
        if (imageKey.indexOf('front') !== -1) return 3;
        if (imageKey.indexOf('duo') !== -1) return 8;
        return 50;
      }

      function reorderTeeGallery() {
        if (root.dataset.productHandle !== 'weg-tee' && root.dataset.productHandle !== 'weeatgod-tshirt') return;
        var thumbStrip = root.querySelector('.ov-product__thumbs');
        if (!thumbStrip) return;
        productThumbs = productThumbs
          .map(function (thumb, index) { return { thumb: thumb, index: index }; })
          .sort(function (a, b) {
            return galleryShotOrder(a.thumb) - galleryShotOrder(b.thumb) || a.index - b.index;
          })
          .map(function (item) { return item.thumb; });
        productThumbs.forEach(function (thumb) { thumbStrip.appendChild(thumb); });
      }

      function filterGalleryByColor(color, selectFirstMatch) {
        var normalizedColor = normalizeGalleryColor(color);
        var exactMatches = productThumbs.filter(function (thumb) {
          return normalizeGalleryColor(thumb.dataset.galleryColor) === normalizedColor;
        });
        var hasColorGallery = normalizedColor && exactMatches.length > 0;

        productThumbs.forEach(function (thumb) {
          var imageColor = normalizeGalleryColor(thumb.dataset.galleryColor);
          thumb.hidden = Boolean(hasColorGallery && imageColor !== normalizedColor && imageColor !== 'shared');
        });

        var activeThumb = root.querySelector('[data-product-thumb].is-active');
        if (hasColorGallery && (selectFirstMatch || !activeThumb || activeThumb.hidden)) {
          activateThumb(exactMatches[0]);
        }
        root.dataset.galleryColor = hasColorGallery ? normalizedColor : 'all';
        updateVisibleGalleryLabels();
        return Boolean(hasColorGallery);
      }

      // Phones: a bar that offers the live action once the main button is gone.
      var buybar = root.querySelector('[data-buybar]');
      var buybarAction = buybar && buybar.querySelector('[data-buybar-action]');
      var buybarVariant = buybar && buybar.querySelector('[data-buybar-variant]');
      var buyArea = root.querySelector('.ov-product__buy') || form;
      function liveAction() {
        if (submit && !submit.hidden) return submit;
        if (restockOpen && !restockOpen.hidden) return restockOpen;
        return null;
      }
      function syncBuybar() {
        if (!buybar || !buybarAction) return;
        var action = liveAction();
        var label = action && action.querySelector('span');
        buybarAction.querySelector('span').textContent = label ? label.textContent : '';
        buybarAction.disabled = !action || action.disabled;
        var variant = findVariant();
        if (buybarVariant) buybarVariant.textContent = variant && variant.title !== 'Default Title' ? displayOptionValue(variant.title) : '';
      }

      function syncPurchaseState() {
        var variant = findVariant();
        var available = Boolean(variant && variant.available);
        var showingAdded = Boolean(feedbackTimer !== null && variant && String(variant.id) === String(addedVariantId));
        if (variantInput) variantInput.value = variant ? variant.id : '';
        if (submit) {
          submit.disabled = requestPending || showingAdded || !available;
          submit.hidden = Boolean(variant && !available && restockOpen);
          submit.classList.toggle('is-loading', requestPending);
          submit.classList.toggle('is-added', showingAdded && available);
          submit.querySelector('span').textContent = !variant ? submit.dataset.unavailableLabel :
            !available ? submit.dataset.soldLabel : showingAdded ? submit.dataset.addedLabel : submit.dataset.addLabel;
        }
        if (restockOpen) restockOpen.hidden = !variant || available;
        if (restockHelper) restockHelper.hidden = !variant || available;
        updateRestockSelection(variant);
        syncBuybar();
        requestMeasure();
        return variant;
      }
      if (buybar && buybarAction && buyArea) {
        buybarAction.addEventListener('click', function () {
          var action = liveAction();
          if (!action || action.disabled) return;
          if (action === submit && form.requestSubmit) form.requestSubmit(submit);
          else action.click();
        });
        // Scroll-driven rather than an observer: a fling from below the button
        // straight past it never changes its intersection, so an observer
        // would never fire. The bar takes over once the live button has gone
        // under the floating header.
        var barShown = false;
        var actionBottom = Infinity;
        onScrollFrame(owner, function (state) {
          var show = actionBottom - state.y < 72;
          if (show === barShown) return;
          barShown = show;
          buybar.classList.toggle('is-shown', show);
          buybar.setAttribute('aria-hidden', String(!show));
          buybarAction.tabIndex = show ? 0 : -1;
          if (show) syncBuybar();
        }, function () {
          actionBottom = docBox(liveAction() || buyArea).bottom;
        });
      }

      function updateVariant(skipImage) {
        var variant = syncPurchaseState();
        if (!variant) {
          if (window.history && window.history.replaceState) {
            var unavailableUrl = new URL(window.location.href);
            unavailableUrl.searchParams.delete('variant');
            window.history.replaceState(window.history.state, '', unavailableUrl.toString());
          }
          return null;
        }
        if (!skipImage && variant.featured_image && variant.featured_image.src) {
          setMainImage(variant.featured_image.src, variant.featured_image.alt);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
        return variant;
      }

      reorderTeeGallery();

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var option = input.closest('.ov-option');
          var label = option && option.querySelector('[data-option-label]');
          if (label) label.textContent = displayOptionValue(input.value);
          var isColorChange = input.dataset.optionName === 'color' || input.dataset.optionName === 'colour';
          var variant = updateVariant(isColorChange);
          if (isColorChange) {
            var hasColorGallery = filterGalleryByColor(input.value, true);
            if (!hasColorGallery && variant && variant.featured_image && variant.featured_image.src) {
              setMainImage(variant.featured_image.src, variant.featured_image.alt);
            }
          }
        });
      });

      productThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(thumb);
        });
      });
      if (galleryPrev) galleryPrev.addEventListener('click', function () { moveGallery(-1); });
      if (galleryNext) galleryNext.addEventListener('click', function () { moveGallery(1); });
      filterGalleryByColor(selectedGalleryColor(), false);
      syncPurchaseState();
      if (colorHold) {
        var initialId = new URL(window.location.href).searchParams.get('variant');
        var initialVariant = product.variants.find(function (item) { return String(item.id) === initialId; });
        if (initialVariant && !isVariantAllowed(initialVariant)) updateVariant(true);
      }

      listen(owner, window, 'popstate', function () {
        var id = new URL(window.location.href).searchParams.get('variant');
        var requestedVariant = product.variants.find(function (item) { return String(item.id) === id; });
        var variant = resolveVariant(requestedVariant);
        if (!variant) return;
        optionInputs.forEach(function (input) {
          input.checked = variant.options[Number(input.dataset.optionPosition) - 1] === input.value;
          if (input.checked) {
            var option = input.closest('.ov-option');
            var label = option && option.querySelector('[data-option-label]');
            if (label) label.textContent = displayOptionValue(input.value);
          }
        });
        if (variantInput) variantInput.value = variant.id;
        if (variant !== requestedVariant) updateVariant(true);
        else syncPurchaseState();
        if (!filterGalleryByColor(selectedGalleryColor(), true) && variant.featured_image) {
          setMainImage(variant.featured_image.src, variant.featured_image.alt);
        }
      });

      if (restockOpen && restockModal) {
        restockOpen.addEventListener('click', openRestock);
        $$('[data-restock-close]', restockModal).forEach(function (button) {
          button.addEventListener('click', function () { closeRestock(true); });
        });
        restockModal.addEventListener('click', function (event) {
          if (event.target === restockModal) closeRestock(true);
        });
        listen(owner, document, 'keydown', function (event) {
          if (!restockModal.classList.contains('is-open')) return;
          if (event.key === 'Escape') closeRestock(true);
          else trapFocus(event, restockModal);
        });
        if ((restockSuccess || restockError) && restockForm && window.location.hash === '#' + restockForm.id) openRestock();
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          if (!window.fetch || (window.Shopify && window.Shopify.designMode)) return;
          event.preventDefault();
          var selectedVariant = findVariant();
          var refreshRequest = 0;
          if (!submit || requestPending || submit.disabled || !selectedVariant || !selectedVariant.available) return;
          if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
          window.clearTimeout(feedbackTimer);
          feedbackTimer = null;
          requestPending = true;
          syncPurchaseState();
          fetch(window.OneVine.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          }).then(function (response) {
            if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
            return response.json();
          }).then(function () {
            requestPending = false;
            if (disposed) return null;
            refreshRequest = ++cartRefreshSequence;
            addedVariantId = selectedVariant.id;
            feedbackTimer = window.setTimeout(function () {
              feedbackTimer = null;
              if (!disposed) syncPurchaseState();
            }, 1800);
            syncPurchaseState();
            // The add has already succeeded. A cart-count refresh failure must
            // not invite a retry that adds a duplicate item.
            return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js')
              .then(function (response) {
                if (!response.ok) throw new Error('Cart count refresh failed.');
                return response.json();
              }).catch(function () {
                if (!disposed && refreshRequest === cartRefreshSequence && errorBox) {
                  errorBox.textContent = 'Your item was added, but the cart total could not refresh. Open your cart to review it.';
                  errorBox.hidden = false;
                }
                return null;
              });
          }).then(function (cart) {
            if (!cart || disposed || refreshRequest !== cartRefreshSequence) return;
            $$('[data-cart-count]').forEach(function (badge) {
              badge.textContent = cart.item_count;
              badge.hidden = cart.item_count === 0;
              badge.style.transform = 'scale(1.5)';
              window.setTimeout(function () { badge.style.transform = 'scale(1)'; }, 250);
            });
            $$('[data-mobile-cart-count]').forEach(function (count) {
              count.textContent = '(' + cart.item_count + ')';
            });
          }).catch(function (error) {
            requestPending = false;
            if (disposed) return;
            syncPurchaseState();
            if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; }
          });
        });
      }
      // The server-rendered selector stays usable if this script is blocked or
      // initialization fails. Reveal custom controls only after wiring them.
      var enhancedProduct = root.querySelector('[data-product-enhanced]');
      var nativeProduct = root.querySelector('[data-product-native]');
      if (enhancedProduct) enhancedProduct.hidden = false;
      if (nativeProduct) nativeProduct.hidden = true;
    });
  }

  // First-drop signup: the floating photos lean away from the pointer.
  function initDropFloat(scope) {
    $$('[data-first-drop]:not([data-float-ready])', scope || document).forEach(function (section) {
      section.dataset.floatReady = 'true';
      var owner = ownerOf(section);
      onTeardown(owner, function () { delete section.dataset.floatReady; });
      if (!depthEnabled() || !finePointer) return;
      // The box is read once on entry; moves are applied at most once a frame.
      var rest = null;
      var point = null;
      var frame = null;
      function apply() {
        frame = null;
        if (!point) return;
        section.style.setProperty('--mx', point.x);
        section.style.setProperty('--my', point.y);
      }
      listen(owner, section, 'pointerenter', function () {
        var rect = section.getBoundingClientRect();
        rest = { left: rect.left, top: rect.top + (window.scrollY || 0), width: rect.width, height: rect.height };
      });
      listen(owner, section, 'pointermove', function (event) {
        if (!rest) return;
        point = {
          x: ((event.pageX - rest.left) / rest.width - 0.5).toFixed(2),
          y: ((event.pageY - rest.top) / rest.height - 0.5).toFixed(2)
        };
        if (frame === null) frame = window.requestAnimationFrame(apply);
      });
      listen(owner, section, 'pointerleave', function () {
        point = { x: '0', y: '0' };
        if (frame === null) frame = window.requestAnimationFrame(apply);
      });
    });
  }

  // Links to the first-drop signup glide there and put the cursor in the field.
  function initJoinLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-join-link]');
      if (!link) return;
      var url;
      try { url = new URL(link.href, window.location.href); } catch (error) { return; }
      if (url.pathname !== window.location.pathname || !url.hash) return;
      var target = document.getElementById(url.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      var field = target.querySelector('input[type="email"]');
      if (!field) return;
      var settled = false;
      function focusField() {
        if (settled) return;
        settled = true;
        field.focus({ preventScroll: true });
      }
      if ('onscrollend' in window) window.addEventListener('scrollend', focusField, { once: true });
      window.setTimeout(focusField, reducedMotion ? 0 : 1400);
    });
  }

  // Phones: a bottom "Join the first drop" dock between the hero and the signup.
  function initJoinDock() {
    var dock = document.querySelector('[data-join-dock]');
    if (!dock || dock.dataset.ready) return;
    dock.dataset.ready = 'true';
    // Product pages have their own buy bar in the same place.
    if (document.querySelector('[data-buybar]')) return;
    var shown = false;
    var heroBottom = null;
    var signupTop = Infinity;
    var portalBox = null;
    onScrollFrame(null, function (state) {
      var pastHero = heroBottom === null ? state.y > state.viewport * 0.8 : heroBottom - state.y < state.viewport * 0.4;
      var nearSignup = signupTop - state.y < state.viewport ||
        Boolean(portalBox && portalBox.top - state.y < state.viewport && portalBox.bottom - state.y > 0);
      var next = !state.wide && pastHero && !nearSignup && !document.body.classList.contains('ov-menu-open');
      if (next === shown) return;
      shown = next;
      dock.classList.toggle('is-shown', shown);
      dock.setAttribute('aria-hidden', String(!shown));
      dock.tabIndex = shown ? 0 : -1;
    }, function () {
      var hero = document.querySelector('[data-hero]');
      var portal = document.querySelector('[data-portal]');
      heroBottom = hero ? docBox(hero).bottom : null;
      portalBox = portal ? docBox(portal) : null;
      signupTop = Infinity;
      $$('[data-first-drop], .ov-footer').forEach(function (element) {
        signupTop = Math.min(signupTop, docBox(element).top);
      });
    });
  }

  // Homepage: a chapter rail built from the sections' data-chapter names.
  function initChapters() {
    var rail = document.querySelector('[data-chapters]');
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = 'true';
    var list = rail.querySelector('ol');
    var fill = rail.querySelector('.ov-chapters__fill');
    var numerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
    var chapters = $$('main [data-chapter]').filter(function (section) { return section.dataset.chapter; }).map(function (section, index) {
      var anchor = section.closest('.shopify-section') || section;
      if (!anchor.id) anchor.id = 'chapter-' + (index + 1);
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + anchor.id;
      link.innerHTML = '<span class="ov-chapters__num"></span><span class="ov-chapters__label"></span>';
      link.firstChild.textContent = numerals[index] || String(index + 1);
      link.lastChild.textContent = section.dataset.chapter;
      item.appendChild(link);
      list.appendChild(item);
      return { section: section, item: item };
    });
    if (chapters.length < 3) return;
    rail.hidden = false;
    var active = -1;
    var hidden = null;
    var footerTop = Infinity;
    var displayed = false;
    var setFill = fill ? writer(fill, 'transform') : function () {};
    onScrollFrame(null, function (state) {
      // The rail only exists on wide screens; elsewhere there is nothing to update.
      if (!displayed) return;
      setFill('scaleY(' + clamp(state.y / state.max, 0, 1).toFixed(3) + ')');
      var current = 0;
      chapters.forEach(function (chapter, index) {
        if (chapter.top - state.y <= state.viewport * 0.5) current = index;
      });
      var hide = current === 0 || footerTop - state.y < state.viewport * 0.7;
      if (current === active && hide === hidden) return;
      active = current;
      hidden = hide;
      chapters.forEach(function (chapter, index) { chapter.item.classList.toggle('is-active', index === current); });
      rail.classList.toggle('is-light', chapters[current].light);
      rail.classList.toggle('is-hidden', hide);
    }, function () {
      displayed = window.getComputedStyle(rail).display !== 'none';
      if (!displayed) return;
      var footer = document.querySelector('.ov-footer');
      footerTop = footer ? docBox(footer).top : Infinity;
      chapters.forEach(function (chapter) {
        chapter.top = docBox(chapter.section).top;
        chapter.light = isLightSurface(chapter.section) === true;
      });
    });
  }

  function initToTop() {
    var button = document.querySelector('[data-totop]');
    if (!button || button.dataset.ready) return;
    button.dataset.ready = 'true';
    var shown = false;
    var setProgress = writer(button, '--ov-progress');
    onScrollFrame(null, function (state) {
      var next = state.y > state.viewport * 1.2 && state.wide;
      // The ring is only drawn while the button is on screen.
      if (next) setProgress(clamp(state.y / state.max, 0, 1).toFixed(3));
      if (next === shown) return;
      shown = next;
      button.classList.toggle('is-shown', shown);
      button.setAttribute('aria-hidden', String(!shown));
      button.tabIndex = shown ? 0 : -1;
    });
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      var logo = document.querySelector('.ov-logo');
      if (logo) logo.focus({ preventScroll: true });
    });
  }

  // Cross-document view transitions are enabled in CSS. Naming the clicked
  // card's photo lets the browser carry it into the product page's stage.
  function initTransitions() {
    if (document.body.dataset.pageTransitions !== 'true' || reducedMotion) return;
    function clearNames() {
      $$('[data-transition-media]').forEach(function (item) { item.style.viewTransitionName = ''; });
      var stage = document.querySelector('[data-product-stage]');
      if (stage) stage.style.viewTransitionName = '';
    }
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;
      clearNames();
      var media = link.querySelector('[data-transition-media]');
      if (!media) return;
      var stage = document.querySelector('[data-product-stage]');
      if (stage) stage.style.viewTransitionName = 'none';
      media.style.viewTransitionName = 'ov-product-media';
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) clearNames();
    });
  }

  function init(scope) {
    initHeader(scope);
    initNewsletterResults(scope);
    initPopup(scope);
    initHero(scope);
    initHeroDepth(scope);
    initReveals(scope);
    initMissionWords(scope);
    initParallax(scope);
    initMarquee(scope);
    initQuestion(scope);
    initFilters(scope);
    initLookbook(scope);
    initPortal(scope);
    initProductImageGuard(scope);
    initProductCardSlideshows(scope);
    initProduct(scope);
    initMagnetic(scope);
    initCounters(scope);
    initInView(scope);
    initDropFloat(scope);
    initOffscreenPause(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIntro();
    init(document);
    initToTop();
    initJoinLinks();
    initJoinDock();
    initChapters();
    initTransitions();
    window.OneVineMotionReady = true;
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { teardown(event.target); });
})();

